import { FieldType } from '90.quickConnect.Models/enums';

const isFieldGroup = (fieldType: FieldType): boolean =>
  fieldType === FieldType.Group || fieldType === FieldType.RepeatableGroup || fieldType === FieldType.Dialog;

export default isFieldGroup;
